import { Link } from "@remix-run/react";
import { ThreeColGrid } from "~/components";

interface Props {
  readonly title?: string;
  readonly message?: string;
  readonly linkLabel?: string;
  readonly locale?: string;
}

const NotFound404Error = ({
  locale = "se",
  title = "Page Not Found",
  message = "Sorry, the page you are looking for does not exist.",
  linkLabel = "Continue Shopping",
}: Props) => {
  return (
    <>
      <div className="flex flex-col justify-center items-center space-y-4 my-5">
        <h1 className="text-2xl md:text-5xl font-masonExtendedBold ">
          {title}
        </h1>
        <p className="text-gray-700">{message}</p>
        <Link to={`/${locale}`} className="underline underline-offset-4">
          {linkLabel}
        </Link>
      </div>

      <ThreeColGrid hasImage />
    </>
  );
};

export default NotFound404Error;
